import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import { ReactSession } from "react-client-session";
import BlogItemSlider from "../../Components/BlogItemSlider/BlogItemSlider";
import "./BlogPage.css";
import p1 from "../../Images/01.jpg";
import ADBanner from "../../Components/ADBanner/ADBanner";
import Comment from "../../Components/Comment/Comment";
import { IoPersonOutline } from "react-icons/io5";
import logo from "../../Images/Logonav.jpg";
import useDocumentTitle from "../../Components/TitleSetter/useDocumentTitle";
function BlogPage(props) {
    const [blogPosts, setBlogPosts] = useState([]);

    const location = useLocation();
    const [postData, setPostData] = useState({});
    const [postTextData, setPostTextData] = useState("");

    useDocumentTitle("باهم | مطالب آموزشی");
    useEffect(() => {
        props.header.current.scrollIntoView({ behavior: "smooth" });
    }, []);

    useEffect(() => {
        axios
            .get("https://hammaskan.ir:8443/api/posts", {
                params: {
                    perPage: 6,
                    page: 0,
                    sort: -1,
                },
            })
            .then((res) => {
                console.log(res.data.data);
                setBlogPosts(res.data.data);
            })
            .catch((error) => {
                // console.log(error);
            });
    }, []);

    useEffect(() => {
        var postId = location.pathname.split("/");
        console.log(postId[2]);
        axios
            .get("https://hammaskan.ir:8443/api/posts/" + postId[2])
            .then((res) => {
                console.log(res.data.data[0]);
                setPostData(res.data.data[0]);
                setPostTextData(res.data.data[0].text);
            })
            .catch((error) => {
                window.location.href = "../";
            });
    }, []);

    useEffect(() => {
        var postId = location.pathname.split("/");
        console.log(postId[2]);
        axios
            .get("https://hammaskan.ir:8443/api/posts/" + postId[2])
            .then((res) => {
                console.log(res.data.data[0]);
                setPostData(res.data.data[0]);
                setPostTextData(res.data.data[0].text);
            })
            .catch((error) => {
                window.location.href = "../";
            });
    }, [location]);

    return (
        <div id="tst" className="blogPage">
            <div className="feedBlog">
                <div className="imageFeedBlog">
                    <div className="imageContainerBlog">
                        <img alt="" src={"https://hammaskan.ir:8443/api/data/image/?imagePath=" + postData.image} />
                        <div className="imageFooterBlog">
                            <h2 className="headPostPageRes">{postData.title}</h2>
                            <div className="infoImageBlog">
                                <span>تاریخ :</span>
                                <span>{postData.updatedAt}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="feedTextBlog" className="feedTextBlog">
                    <div
                        dangerouslySetInnerHTML={{
                            __html: postTextData,
                        }}
                    ></div>
                    <br />
                    <br />
                    {/* <div className="tagtextBlog">
                        <div className="tagItemBlog">
                            <div>کارشناسی ملک</div>
                        </div>
                    </div> */}
                    <div className="infItemSliderBlog">
                        {/* <div>نوشته شده توسط {props.username}</div> */}
                        <div style={{ display: "flex", justifyContent: "space-between", width: "100px" }}>
                            <span>{postData.updatedAt}</span>
                        </div>
                    </div>
                </div>
                <div className="commentsBlogPage">
                    <div className="headerComments">
                        <h2>دیدگاه کاربران</h2>
                    </div>
                    <div className="addCommentDiv">
                        <span>آدرس ایمیل شما منتشر نخواهد شد. فیلد های مورد نیاز علامت گذاری شده اند *</span>
                        <div className="inputsRosBlog">
                            <div className="nameInputCommentBlog">
                                <input placeholder="نام و نام خانوادگی ..." />
                            </div>
                            <div className="emailInputCommnetBlog">
                                <input placeholder="آدرس ایمیل..." />
                            </div>
                        </div>
                        <div className="CommentTextAreaInput">
                            <textarea placeholder="توضیحات..." />
                        </div>
                    </div>
                    <div className="commentsContainer">
                        <span>نظرات کاربران در رابطه با این نوشته :</span>
                        <div className="commentsListBlog">
                            {/* <Comment Icon={IoPersonOutline} name="متیو ان پی" date="1400/12/01" time="11:30" text="لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است">
                                <Comment reply Icon={IoPersonOutline} name="متیو ان پی" date="1400/12/01" time="11:30" text="لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است." />
                                <Comment reply Icon={IoPersonOutline} name="متیو ان پی" date="1400/12/01" time="11:30" text="لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است." />
                            </Comment>
                            <Comment Icon={IoPersonOutline} name="متیو ان پی" date="1400/12/01" time="11:30" text="لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است">
                                <Comment reply Icon={IoPersonOutline} name="متیو ان پی" date="1400/12/01" time="11:30" text="لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است." />
                            </Comment> */}
                        </div>
                    </div>
                </div>
            </div>
            <div className="sidebarBlog">
                <div className="bannerDivBlog">
                    <div className="crossLineLogoBlog">
                        <div className="iconLogo">
                            <img alt="" src={logo} />
                        </div>
                        <div className="btnDivsRowBannerPageBlog">
                            <Link
                                to={{
                                    pathname: "../karshenasi",
                                    // state: {
                                    //   postData: blogPosts[0],
                                    // },
                                }}
                            >
                                <div className="btn1bannerLogo">کارشناسی ملک با ضمانت باهم</div>
                            </Link>
                            <Link
                                to={{
                                    pathname: "../newagahi",
                                    // state: {
                                    //   postData: blogPosts[0],
                                    // },
                                }}
                            >
                                <div className="btn2bannerLogo">فروش سفارشی ملک</div>
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="topsBlog">
                    <div className="topsHeaderBlog">
                        <h3>محبوب ترین ها</h3>
                    </div>
                    {blogPosts.length !== 0 ? (
                        <div className="topsItemsList">
                            {blogPosts.map(function (item, i) {
                                return (
                                    <Link to={{ pathname: "/post/" + item.id }}>
                                        <BlogItemSlider image={"https://hammaskan.ir:8443/api/data/image/?imagePath=" + item.image} title={item.title} time="6" date={item.updatedAt} />
                                    </Link>
                                );
                            })}
                        </div>
                    ) : (
                        <div className="topsItemsList">
                            <BlogItemSlider image={""} time={"6"} date={"1400/11/01"} tag={"کارشناسی ملک"} title={"مشاعات ساختمان چیست؟"} />
                            <BlogItemSlider image={""} time={"6"} date={"1400/11/01"} tag={"کارشناسی ملک"} title={"مشاعات ساختمان چیست؟"} />
                            <BlogItemSlider image={""} time={"6"} date={"1400/11/01"} tag={"کارشناسی ملک"} title={"مشاعات ساختمان چیست؟"} />
                            <BlogItemSlider image={""} time={"6"} date={"1400/11/01"} tag={"کارشناسی ملک"} title={"مشاعات ساختمان چیست؟"} />
                            <BlogItemSlider image={""} time={"6"} date={"1400/11/01"} tag={"کارشناسی ملک"} title={"مشاعات ساختمان چیست؟"} />
                            <BlogItemSlider image={""} time={"6"} date={"1400/11/01"} tag={"کارشناسی ملک"} title={"مشاعات ساختمان چیست؟"} />
                        </div>
                    )}
                </div>
                {/* <div className="ADbanners">
                    <ADBanner />
                </div>
                <div className="ADbanners">
                    <ADBanner />
                </div> */}
            </div>
        </div>
    );
}

export default BlogPage;
